import React, { Fragment } from 'react';
import FormNfce from '../../../components/nota-fiscal-consumidor/form-nfce';
import NavBar from '../../../components/layout/navbar/index';

export default function Nfce(props) {
    const nfeTemp = props.location.state.registroUnico;
    return (
        <Fragment>
            <NavBar />
            <FormNfce nfeDados={nfeTemp ? nfeTemp : {}} />
        </Fragment>
    )
}